
import React, { useState } from "react";
import toast from "react-hot-toast";
import { IconButton } from "../../components";
import { FiltersAppliedWarningMessage, Main, PageSubHeader, ThemedIcon } from "../../components/utilities";
import { useFilterContext } from "../../hooks/FilterContext";
import CorporateActionPairsGrid from "./components/CorporateActionPairsGrid";
import CorporateActionPairsGridFilterModal from "./components/CorporateActionPairsGridFilterModal";
import EditCorporateActionPairModal from "./components/EditCorporateActionPairModal";
import CorporateActionPairsProvider, { useCorporateActionPairs } from "./hooks/CorporateActionPairsContext";

const CorporateActionPairsHeader = () => {
    const [isFiltersShown, setIsFiltersShown] = useState();
    const {
        createPair,
        createResult
    } = useCorporateActionPairs();

    const {
        clearFilter,
        isFiltersApplied,
    } = useFilterContext();

    const onCreate = (e) => {
        e.preventDefault();

        toast.promise(createPair(), {
            loading: "Creating action pair...",
            error: "Unable to create action pair.",
            success: "Action pair created!"
        });
    };

    return (
        <>
            <PageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                </FiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                        <IconButton icon={['fas', 'filter']} onClick={() => setIsFiltersShown(true)}>
                            Filter Action Pairs
                        </IconButton>
                        <IconButton
                            onClick={onCreate}
                            disabled={createResult.isLoading}
                            variant="success"
                            icon={"fa-plus"}
                        >
                            Create New Action Pair
                        </IconButton>
                    </div>
                </div>
            </PageSubHeader>
            <CorporateActionPairsGridFilterModal
                show={isFiltersShown}
                onHide={() => setIsFiltersShown(null)}
            />
            <EditCorporateActionPairModal />
        </>
    )
};


const CorporateActionPairsManagement = () => (
    <CorporateActionPairsProvider>
        <Main className="d-flex flex-column">
            <CorporateActionPairsHeader />
            <section className="px-4 my-3 h-100">
                <CorporateActionPairsGrid />
            </section>
        </Main>
    </CorporateActionPairsProvider>
);

export default CorporateActionPairsManagement;